import { Link } from "react-router-dom";
import { database } from "../../common/database";
import { formatDate } from "../../common/format";

const MAX_RELATED = 3;

function sharedTopics(a, b) {
    return [...a.topics].filter(topic => b.topics.has(topic)).length;
}

function KeepReading(props) {
    // The database is sorted newest first, so the neighbors on either side are the adjacent posts.
    const idx = database.findIndex(post => post.slug === props.slug);
    if (idx === -1) {
        return null;
    }

    const current = database[idx];
    const newer = database[idx - 1];
    const older = database[idx + 1];

    // Rank other posts by how many topics they share, breaking ties by closeness in time.
    const related = database
        .filter(post => post !== current && post !== newer && post !== older && sharedTopics(post, current) > 0)
        .sort((a, b) => sharedTopics(b, current) - sharedTopics(a, current)
            || Math.abs(a.date - current.date) - Math.abs(b.date - current.date))
        .slice(0, MAX_RELATED);

    return (
        <div className="keep-reading">
            {related.length > 0 && (
                <>
                    <p className="keep-reading-label">More in {[...current.topics].join(", ")}</p>
                    <ul className="keep-reading">
                        {related.map(post =>
                            <li className="keep-reading" key={post.slug}>
                                <Link className="keep-reading" to={"/" + post.slug}>{post.title}</Link>
                                <span className="keep-reading-date">{formatDate(post.date)}</span>
                            </li>
                        )}
                    </ul>
                </>
            )}
            <div className="adjacent-posts">
                {older && <Link className="older" to={"/" + older.slug}>← {older.title}</Link>}
                {newer && <Link className="newer" to={"/" + newer.slug}>{newer.title} →</Link>}
            </div>
        </div>
    );
}

export default KeepReading;
